<template>
	<div>
		<transition name="slide">
			<div v-if="isDrawerOpen" class="drawer">
				<div class="inner-drawer">
					<div class="drawer-content">
						<div class="agent-info">
							<pre>Status:</pre>
							<pre>{{ agentInfo?.active ? "Running" : "Not running" }}</pre>
						</div>
						<div class="agent-info">
							<pre>CPU Usage:</pre>
							<pre>{{ agentInfo?.cpuUsage || "0" }}%</pre>
						</div>
						<div class="agent-info">
							<pre>Mem Usage:</pre>
							<pre>{{ agentInfo?.memoryUsage || "0" }}%</pre>
						</div>
						<div class="marginSmallBottom">
							<pre>Logs:</pre>
							<code
								:class="agentInfo?.active ? 'success' : 'neutral'"
								title="Read-only"
							>
								{{ stream.join("\n") }}
							</code>
						</div>
					</div>
					<div class="drawer-action">
						<div>
							<button
								v-if="!agentInfo?.active"
								class="button successButton"
								@click="startAgent"
							>
								Start Agent
							</button>
							<button
								v-if="agentInfo?.active"
								class="button dangerButton"
								@click="stopAgent"
							>
								Stop Agent
							</button>
						</div>
						<button class="button" @click="toggleDrawer">Close</button>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: "AgentInfoDrawer",
	data() {
		return {
			isDrawerOpen: false,
			agentInfo: null,
			stream: [],
			agentEventSource: null,
		};
	},
	mounted() {
		this.subscribeToSSE();
		this.$root.$on("agent-info-updated", this.updateAgentInfo);
		this.$root.$on("toggle-drawer", this.toggleDrawer);
	},
	beforeDestroy() {
		this.unsubscribeFromSSE();
		this.$root.$off("toggle-drawer", this.toggleDrawer);
		this.$root.$off("agent-info-updated", this.updateAgentInfo);
	},
	methods: {
		subscribeToSSE() {
			this.agentEventSource = new EventSource(
				`/api/active_auction/?action=agent:log`,
				{
					withCredentials: true,
				}
			);
			this.agentEventSource.onopen = () => {
				// console.debug('SSE connection opened');
			};
			this.agentEventSource.onmessage = (event) => {
				try {
					const data = JSON.parse(event.data);
					// console.info('Parsed AUCTION_AGENT_LOG data: ', data);
					this.stream = [...this.stream, ...data.data];
					// Scroll to the bottom of the code block
					const codeBlock = this.$el.querySelector("code");
					if (codeBlock) {
						this.$nextTick(() => {
							const codeBlock = this.$el.querySelector("code");
							codeBlock.scrollTop = codeBlock.scrollHeight;
						});
					}
				} catch (error) {
					console.error("Error parsing JSON: ", error);
				}
			};
			this.agentEventSource.onerror = (error) => {
				console.error("SSE error: ", error);
			};
			window.addEventListener("beforeunload", this.unsubscribeFromSSE);
		},
		startAgent() {
			fetch("/api/active_auction/", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					action: "agent:start",
					x_auth_token: $cookies.get("llatoken"),
				}),
			})
				.then((response) => {
					console.info("Agent started: ", response);
					this.toggleDrawer();
				})
				.catch((error) => {
					console.error("Error starting agent: ", error);
				});
		},
		stopAgent() {
			fetch("/api/active_auction/", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					action: "agent:stop",
					x_auth_token: $cookies.get("llatoken"),
				}),
			})
				.then((response) => {
					console.info("Agent stopped: ", response);
				})
				.catch((error) => {
					console.error("Error stopping agent: ", error);
				});
		},
		toggleDrawer() {
			this.isDrawerOpen = !this.isDrawerOpen;
			// Scroll to the bottom of the code block
			this.$nextTick(() => {
				const codeBlock = this.$el.querySelector("code");
				codeBlock.scrollTop = codeBlock.scrollHeight;
			});
		},
		updateAgentInfo(info) {
			this.agentInfo = info;
		},
		unsubscribeFromSSE() {
			if (this.agentEventSource) {
				this.agentEventSource.close();
			}
			window.removeEventListener("beforeunload", this.unsubscribeFromSSE);
		},
	},
};
</script>

<style scoped>
code {
	display: block;
	height: inherit;
	min-height: 200px;
	max-height: 600px;
	width: 100%;
	overflow-y: scroll;
	word-wrap: break-word;
	white-space: pre-line;
}

code.success {
	background-color: #d4edda;
	color: #155724;
	font-family: Menlo, Monaco, "Courier New", monospace;
	font-size: 14px;
	line-height: 1.5;
	padding: 16px;
}

code.neutral {
	background-color: #eee;
	color: #111;
	font-family: Menlo, Monaco, "Courier New", monospace;
	font-size: 14px;
	line-height: 1.5;
	padding: 16px;
}

pre {
	margin: initial;
}

.drawer {
	position: fixed;
	right: 0;
	top: 46px;
	min-width: 400px;
	width: 50vw;
	height: calc(100% - 46px);
	padding: 40px 20px 20px;
	background-color: white;
	box-shadow: -10px 0 25px rgba(0, 0, 0, 0.1);
	z-index: 1000;
	transition: transform 0.3s ease;
}

.inner-drawer {
	display: flex;
	flex-direction: column;
	height: 100%;
	position: relative;
}

.slide-enter-active,
.slide-leave-active {
	transition: transform 0.3s ease;
}

.slide-enter,
.slide-leave-to {
	transform: translateX(100%);
}

.drawer-content {
	flex: 1;
	display: flex;
	flex-direction: column;
	height: 100%;
}

.drawer-action {
	margin-top: 20px;
	text-align: right;
	display: flex;
	justify-content: space-between;
}

.agent-info {
	display: flex;
	justify-content: space-between;
	margin-bottom: 8px;
}

.button {
	background-color: #007aff;
	color: white;
	border: 1px solid #007aff;
	border-radius: 4px;
}
</style>
